// JsFromRoutes CacheKey fbac75c3662ae615ffb4e4260050611e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  all: /* #__PURE__ */ definePathHelper("get", "/projects/all")
};
